import { useFormik } from "formik";
import React, { useState, useEffect } from "react";
import { FaPlus } from "react-icons/fa";
import { toast } from "react-toastify";
import { httpReauest } from "../../../utils/httpRequest";
import * as Yup from "yup";
import { BASE_URL } from "../../../config";
import Loading from "../Loading";
import { FaTrash } from "react-icons/fa6";
import ReactQuill from "react-quill";

const CreateProductForm = () => {
  const [images, setImages] = useState([]);
  const [previews, setPreview] = useState([]);
  const [categorys, setCategorys] = useState([]);
  const [loading, setloading] = useState(false);
  const [single, setsingle] = useState("notselect");

  const VALUE_SIGN_VALIDATION = () => {
    return Yup.object({
      name: Yup.string().required("الزامی است"),
    });
  };

  async function deleteImg(index) {
    setPreview((prev) => prev.filter((_, i) => i !== index));
    setImages((prev) => prev.filter((_, i) => i !== index));
  }

  const formik = useFormik({
    initialValues: {
      name: "",
      desc: "",
      category: [],
      balance: "",
      height: "",
      size: "",
      price: "",
      special_price: "",
      url: "",
      products: [{ color: "", colorCode: "#000000", size: "", balance: "" }],
    },
    validationSchema: VALUE_SIGN_VALIDATION,
    onSubmit: async (values) => {
      setloading(true);
      const user = JSON.parse(localStorage.getItem("user"));
      const formdata = new FormData();
      const newPrice = Number(values.price?.replaceAll(",", ""));
      formdata.append("price", newPrice);

      if (values.special_price) {
        const newSpecialPrice = Number(
          values.special_price?.replaceAll(",", "")
        );
        formdata.append("special_price", newSpecialPrice);
      }

      formdata.append("name", values.name);
      formdata.append("height", values.height);
      formdata.append("url", values.url);
      formdata.append("category", JSON.stringify(values.category));
      formdata.append("desc", values.desc);

      if (single === "true") {
        formdata.append("single", true);
        formdata.append("size", values.size);
        formdata.append("balance", values.balance);
      } else {
        formdata.append("products", JSON.stringify(values.products));
      }

      if (images.length > 0) {
        for (let index = 0; index < images.length; index++) {
          formdata.append("images", images[index], images[index]?.name);
        }
      }

      try {
        const response = await fetch(BASE_URL + "/product", {
          method: "POST",
          body: formdata,
          headers: { "x-access-token": user?.token },
        });

        const res = await response.json();
        if (response.status === 201) {
          toast.success("محصول ساخته شد");
          formik.resetForm();
          setImages([]);
          setPreview([]);
        } else {
          toast.error(res.message);
        }
      } catch (err) {
        toast.error("خطا در برقراری ارتباط با سرور");
      } finally {
        setloading(false);
      }
    },
  });

  useEffect(() => {
    getData();
  }, []);

  function handleImages(e) {
    const fils = e.target.files;
    if (fils) {
      for (let index = 0; index < fils?.length; index++) {
        if (fils[index].size > 2031517) {
          toast.error("حجم فایل باید کمتر از دو مگابایت باشد");
        } else {
          setImages((current) => [...current, fils[index]]);
          setPreviwImages(fils[index]);
        }
      }
    }
  }

  async function setPreviwImages(i) {
    const reader = new FileReader();
    reader.onloadend = function () {
      setPreview((current) => [...current, reader.result]);
    };
    reader.readAsDataURL(i);
  }

  async function getData() {
    await httpReauest("GET", "/category", {}, {}).then(({ data }) => {
      setCategorys(data?.data);
    });
  }

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  function handleChange(value) {
    formik.setFieldValue("desc", value);
  }

  function handleDeleteCategory(_id) {
    const filtered = formik.values.category.filter((item) => item !== _id);
    formik.setFieldValue("category", filtered);
  }

  function handleAddCategory(_id) {
    if (formik.values.category.includes(_id) || _id === "" || !_id) {
      return;
    }
    const filtered = [...formik.values.category, _id];
    formik.setFieldValue("category", filtered);
  }

  function handleChangePrice(params) {
    const value = params.target.value;
    const formattedValue = (
      Number(value.replace(/\D/g, "")) || ""
    ).toLocaleString();
    formik.setFieldValue("price", formattedValue);
  }

  function handleChangeSpecialPrice(params) {
    const value = params.target.value;
    const formattedValue = (
      Number(value.replace(/\D/g, "")) || ""
    ).toLocaleString();
    formik.setFieldValue("special_price", formattedValue);
  }

  // اصلاح مدیریت آپدیت محصولات در فرمیک
  function handleChangeProduct(value, field, index) {
    const updatedProducts = [...formik.values.products];
    updatedProducts[index] = {
      ...updatedProducts[index],
      [field]: value,
    };
    formik.setFieldValue("products", updatedProducts);
  }

  function handleAddProduct() {
    formik.setFieldValue("products", [
      ...formik.values.products,
      { color: "", colorCode: "#000000", size: "", balance: "" },
    ]);
  }

  function handleRemoveProduct(index) {
    const updated = formik.values.products.filter((_, i) => i !== index);
    formik.setFieldValue("products", updated);
  }

  return (
    <div>
      <h2 className="text-[20px] mb-8 font-bold p-3">فرم ایجاد محصول</h2>
      <form
        onSubmit={formik.handleSubmit}
        className="grid grid-cols-1 lg:grid-cols-3 2xl:grid-cols-4 gap-6"
      >
        <span className="relative">
          <select
            id="single"
            name="single"
            onChange={(e) => setsingle(e.target.value)}
            className="w-full form-brand h-[48px]"
          >
            <option value="notselect">انتخاب کنید</option>
            <option value="true">تک محصول</option>
            <option value="false">چند محصول</option>
          </select>
          <p className="on-border font-bold">نوع محصول*</p>
        </span>

        {single !== "notselect" && (
          <>
            <span className="relative">
              <input
                placeholder="مثلا : دستبند النگویی"
                id="name"
                name="name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="w-full form-brand h-[48px]"
              />
              {formik.errors.name && formik.touched.name && (
                <small style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.name}
                </small>
              )}
              <p className="on-border font-bold">نام محصول*</p>
            </span>

            <span className="relative">
              <input
                id="url"
                name="url"
                value={formik.values.url}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="w-full form-brand h-[48px]"
              />
              <p className="on-border font-bold">url*</p>
            </span>

            <span className="relative">
              <input
                id="price"
                name="price"
                value={formik.values.price}
                onChange={handleChangePrice}
                onBlur={formik.handleBlur}
                className="w-full form-brand h-[48px]"
              />
              {formik.errors.price && formik.touched.price && (
                <small style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.price}
                </small>
              )}
              <p className="absolute translate-y-[-50%] top-[24px] left-4">
                تومان
              </p>
              <p className="on-border font-bold">قیمت محصول*</p>
            </span>

            <span className="relative">
              <input
                id="special_price"
                name="special_price"
                value={formik.values.special_price}
                onChange={handleChangeSpecialPrice}
                onBlur={formik.handleBlur}
                className="w-full form-brand h-[48px]"
              />
              {formik.errors.special_price && formik.touched.special_price && (
                <small style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.special_price}
                </small>
              )}
              <p className="absolute translate-y-[-50%] top-[24px] left-4">
                تومان
              </p>
              <p className="on-border font-bold">
                قیمت با تخفیف(در صورتی که تخفیف دارد)
              </p>
            </span>

            <span className="relative">
              <select
                id="category"
                name="category"
                onChange={(e) => handleAddCategory(e.target.value)}
                className="w-full form-brand h-[48px]"
              >
                <option value="">انتخاب کنید</option>
                {categorys?.map((e) => (
                  <option key={e._id} value={e._id}>
                    {e.name}
                  </option>
                ))}
              </select>
              {formik.errors.category && formik.touched.category && (
                <small style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.category}
                </small>
              )}
              <p className="on-border font-bold">دسته بندی*</p>
              <span>دسته بندی های انتخاب شده:</span>
              {categorys?.map((cat) =>
                formik.values.category.map((item) => {
                  if (item === cat._id) {
                    return (
                      <div
                        key={cat._id}
                        className="flex justify-between items-center my-0.5"
                      >
                        <span>{cat.name}</span>
                        <FaTrash
                          onClick={() => handleDeleteCategory(item)}
                          className="cursor-pointer"
                          color="red"
                        />
                      </div>
                    );
                  }
                  return null;
                })
              )}
            </span>

            <span className="relative">
              <input
                placeholder="مثلا : 100cm"
                id="height"
                name="height"
                value={formik.values.height}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="text"
                className="w-full form-brand h-[48px]"
              />
              <p className="on-border font-bold">قد محصول*</p>
            </span>

            {single === "true" && (
              <>
                <span className="relative">
                  <input
                    placeholder="مثلا : 10"
                    id="balance"
                    name="balance"
                    value={formik.values.balance}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="number"
                    className="w-full form-brand h-[48px]"
                  />
                  <p className="on-border font-bold">تعداد*</p>
                </span>
                <span className="relative">
                  <input
                    placeholder="مثلا : فری 36 تا 42"
                    id="size"
                    name="size"
                    value={formik.values.size}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    className="w-full form-brand h-[48px]"
                  />
                  <p className="on-border font-bold">سایز*</p>
                </span>
              </>
            )}

            {/* بخش چند محصولی بر اساس formik.values.products */}
            {single === "false" && (
              <>
                {formik.values.products?.map((item, index) => (
                  <div
                    key={index}
                    className="col-span-full grid grid-cols-1 lg:grid-cols-3 2xl:grid-cols-4 gap-6 p-4 border rounded-lg relative"
                  >
                    <div className="col-span-full flex justify-between items-center">
                      <h3 className="text-[22px] font-bold">
                        محصول {index + 1}
                      </h3>
                      {formik.values.products.length > 1 && (
                        <FaTrash
                          onClick={() => handleRemoveProduct(index)}
                          className="cursor-pointer"
                          color="red"
                          size={20}
                        />
                      )}
                    </div>

                    <span className="relative">
                      <input
                        id={`color-${index}`}
                        value={item.color || ""}
                        onChange={(e) =>
                          handleChangeProduct(e.target.value, "color", index)
                        }
                        type="text"
                        className="w-full form-brand h-[48px]"
                      />
                      <p className="on-border font-bold">اسم رنگ*</p>
                    </span>

                    <span className="relative">
                      <input
                        id={`colorCode-${index}`}
                        value={item.colorCode || "#000000"}
                        onChange={(e) =>
                          handleChangeProduct(
                            e.target.value,
                            "colorCode",
                            index
                          )
                        }
                        type="color"
                        className="w-full form-brand h-[48px]"
                      />
                      <p className="on-border font-bold">کد رنگی*</p>
                    </span>

                    <span className="relative">
                      <input
                        id={`balance-${index}`}
                        value={item.balance || ""}
                        onChange={(e) =>
                          handleChangeProduct(e.target.value, "balance", index)
                        }
                        type="text"
                        className="w-full form-brand h-[48px]"
                      />
                      <p className="on-border font-bold">تعداد*</p>
                    </span>

                    <span className="relative">
                      <input
                        id={`size-${index}`}
                        value={item.size || ""}
                        onChange={(e) =>
                          handleChangeProduct(e.target.value, "size", index)
                        }
                        type="text"
                        className="w-full form-brand h-[48px]"
                      />
                      <p className="on-border font-bold">سایز*</p>
                    </span>
                  </div>
                ))}

                <span className="flex col-span-full gap-2 items-center my-2">
                  <button
                    type="button"
                    onClick={handleAddProduct}
                    className="flex items-center gap-2 bg-gray-200 px-4 py-2 rounded-md hover:bg-gray-300 transition"
                  >
                    <FaPlus size={18} />
                    <span>افزودن تنوع جدید</span>
                  </button>
                </span>
              </>
            )}

            <span dir="ltr" className="col-span-full">
              <h2 className="title text-right">:توضیح</h2>
              <ReactQuill
                value={formik.values.desc}
                modules={{
                  toolbar: [
                    [{ header: [1, 2, false], font: ["Opens Sans"] }, {}],
                    ["bold", "italic", "underline", "strike", "blockquote"],
                    [
                      { list: "ordered" },
                      { list: "bullet" },
                      { indent: "-1" },
                      { indent: "+1" },
                    ],
                    ["link", "image", "code"],
                    ["clean"],
                  ],
                }}
                formats={formats}
                onChange={handleChange}
              />
            </span>

            <div className="relative col-span-full w-full border-dashed border rounded-[10px] p-3 min-h-[340px] border-[#444]">
              {previews?.length > 0 ? (
                <div
                  className="p-3"
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "15px",
                  }}
                >
                  {previews.map((src, i) => (
                    <span key={i} className="relative">
                      <img
                        src={src}
                        style={{
                          width: "150px",
                          height: "150px",
                          objectFit: "contain",
                        }}
                        alt=""
                      />
                      <FaTrash
                        color="red"
                        className="top-0 right-0 absolute cursor-pointer"
                        onClick={() => deleteImg(i)}
                      />
                    </span>
                  ))}
                  <label htmlFor="images" className="cursor-pointer">
                    <FaPlus size={50} />
                  </label>
                </div>
              ) : (
                <label htmlFor="images" className="cursor-pointer">
                  <FaPlus className="center" size={50} />
                </label>
              )}

              <p className="on-border font-bold">تصاویر</p>
            </div>

            <input
              onChange={handleImages}
              type="file"
              className="hidden"
              id="images"
              multiple
              accept="image/png, image/jpg, image/jpeg"
            />

            {loading ? (
              <Loading />
            ) : (
              <button type="submit" className="btn-brand">
                ارسال
              </button>
            )}
          </>
        )}
      </form>
    </div>
  );
};

export default CreateProductForm;